import React from "react";
import { connect } from "react-redux";
import * as sessionActions from "./modules/session";
import DisabledAlert from "./components/disabledPage/DisabledAlert";
import { history } from "./storeInitializer";
import request from "./config";
import { t } from "i18next";
import PropTypes from "prop-types";
import { alertError, alertSuccess } from "./utils/alerts";
import { isMobile, isAndroid } from "react-device-detect";
import Modal from "Components/smallModal/smallModal";
import { hasNotch, getSafeAreas } from "Utils/hasNotch";
import OTPConfig from "./screens/settings/OTPConfig.jsx";
import ChangePasswordModal from "Components/changePasswordModal/ChangePasswordModal";
import _ from "lodash";
import QboxmailApi from "./qboxmailApi";
import { formatServerErrors } from "Utils/serverFormats";
import { ToastContainer } from "react-toastify";
import * as resActions from "./modules/resources";
import AdminRoutes from "./routes/admin";
import CustomerRoutes from "./routes/customer";
import PostmasterRoutes from "./routes/postmaster";
import EmailRoutes from "./routes/emailAccount";
import NoLoggedRoutes from "./routes/noLogged";
import TrialExpiredRoutes from "./routes/trialExpired";
import TmRoutes from "./routes/teamMember";
import ManagerRoutes from "./routes/manager";
import sessionStore from "@/stores/session";
import { Helmet } from "react-helmet";
import { view } from "@risingstack/react-easy-state";
import { SwrContext, TourContext } from "ReactContext/index";
import DeclareTypeModal from "Components/declareTypeModal/DeclareTypeModal";
import Tour from "@/tour/Tour";
import { isVianovaHost } from "Utils/vianova";

import { setupI18n } from "./i18nConf.js";

const MediaQueriesContext = React.createContext({});
const AuthContext = React.createContext({});

setupI18n()

class App extends React.Component {
  constructor(props) {
    super(props);

    this.verifySession();

    if (props.loggedUser) {
      this.setCustomizationInStore(props.loggedUser);
    }

    // if (process.env.NODE_ENV !== "development" && !IS_APP && window.ga) {
    //   window.ga(function (tracker) {
    //     var trackers = ga.getAll();
    //     console.log("trackers", trackers);
    //     window.gaTracker = trackers[0];
    //   });
    // }

    // safe areas for notch calc
    if (IS_APP && hasNotch()) {
      console.log("This mobile phone seems to have a notch");
      const safeAreas = getSafeAreas();
      console.log("This mobile phone seems to have safe areas", safeAreas.top, safeAreas.bottom);
      if (safeAreas.top > 0) {
        //document.body.style.paddingTop = `${safeAreas.top}px`;
        document.documentElement.style.setProperty("--safetop", `${safeAreas.top}px`);
      }
      if (safeAreas.bottom > 0) {
        //document.body.style.paddingBottom = `${safeAreas.bottom}px`;
        document.documentElement.style.setProperty("--safebottom", `${safeAreas.bottom}px`);
      }
    }

    // safe areas for status bar phone
    if (IS_APP && !hasNotch() && !isAndroid) {
      document.documentElement.style.setProperty("--safetop", `24px`);
    }

    this.handleResize = _.debounce(this.handleResize.bind(this), 200);
    this.state = {
      verifingSession: true,
      // Breakpoints helpers
      isMobileDevice: isMobile,
      isMediaMobile: false,
      isMediaSM: false,
      isMediaMD: false,
      isMediaLG: true,
      showSidebar: true,
      compactSidebar: false,
      otpModalOpened: false,
      changePwdModalOpened: false,
      declareTypeModalOpened: false,

      userType: undefined,
      isTrialExpired: undefined,

      changePasswordForm: {},
      changePasswordFormErrors: {},

      ...this.calcMediaQueries(),
      withTour: false,
      runTour: false,
    };
  }

  getChildContext() {
    const { loggedUser } = this.props;
    return {
      getLoggedUser: () => this.props.loggedUser,
      getLoggedUserType: () => this.props.loggedUserType,
      isLoggedUserTrial: () => loggedUser?.plan === "trial",
      isLoggedUserAdmin: () => loggedUser?.type === "Admin",
      isLoggedUserExpired: () => {
        return loggedUser?.plan === "trial" && loggedUser?.days_until_expiration <= -1;
      },
      isMobileDevice: () => this.state.isMobileDevice,
      isMediaMobile: () => this.state.isMediaMobile,
      isMediaSM: () => this.state.isMediaSM,
      isMediaMD: () => this.state.isMediaMD,
      isMediaLG: () => this.state.isMediaLG,
      showSidebar: () => this.state.showSidebar,
      compactSidebar: () => this.state.compactSidebar,
    };
  }

  logout = () => {
    window.qb_requestedURL = ""; // reset the visited url
    window.qbpanel_isLoggingOut = true;
    this.props.resetResourcesStore();
    this.props.logout();

    this.setState({
      userType: undefined,
      isTrialExpired: undefined,
      withTour: false,
      runTour: false,
    });
  };

  async initializeTour(user) {
    this.setState({
      withTour: true,
      runTour: !user.has_seen_intro_tour,
    });
  }

  componentDidMount() {
    this.redirectEtliveRequests();

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("orientationchange", this.handleResize);

    const { loggedUser } = this.props;
    window.qbpanel_tz = "utc"; // TODO orribile soluzione
    let emailType = null;
    if (loggedUser) {
      sessionStore.setSettings({
        language: loggedUser.language,
        timezone: loggedUser.timezone,
      });

      emailType = loggedUser.type === "EmailAccount" || loggedUser.type === "Postmaster";
    }

    if (
      loggedUser &&
      emailType &&
      (loggedUser.domain_force_otp || loggedUser.force_otp) &&
      !loggedUser.otp &&
      !this.state.otpModalOpened
    ) {
      this.showForceOTPModal();
    }

    if (loggedUser && emailType && (loggedUser.password_expired || loggedUser.force_new_password)) {
      this.showChangePasswordModal();
    }

    if (loggedUser && loggedUser.type === "Customer") {
      this.initializeTour(loggedUser);
    }

    // Fetch and log application version
    const api = new QboxmailApi({ useCookie: true });
    api.getSystemVersion()
      .then(response => {
        const version = response.resources[0].version;
        console.log(`QbPanel Version: ${version}`);
      })
      .catch(error => {
        console.warn('Failed to fetch application version:', error);
      });
  }

  redirectEtliveRequests() {
    if (this.props.history.location.pathname == "/etlive") {
      const query = this.props.history.location.search;
      const replaced = "/tracemail" + query;
      this.props.history.replace(replaced);
      window.qb_requestedURL = replaced;
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize);
  }

  shouldComponentUpdate(nextProps) {
    // when session is not valid anymore, block rendering of the app and redirect to login
    if (!nextProps.loggedUser && this.props.loggedUser) {
      this.handleSessionExpired();
      return false;
    }

    return true;
  }

  handleSessionExpired() {
    this.setState({ userType: null });
    this.props.history.replace("/login");

    if (window.qbpanel_isLoggingOut) {
      window.qbpanel_isLoggingOut = false;
    } else {
      alertError(t("alert.session.exiped"));
    }
  }

  refreshSession = async () => {
    const { setSession } = this.props;
    const api = new QboxmailApi({ useCookie: true });
    const response = await api.refreshAccount();
    const user = response.resources[0];

    setSession(user);
  };

  verifySession = () => {
    const requestConfig = {
      method: "GET",
      url: "/users/session",
    };

    request(requestConfig)
      .then(({ data }) => {
        const { history, setSession } = this.props;
        const user = data.resources[0];
        setSession(user);

        sessionStore.setSettings({
          language: user.language,
          timezone: user.timezone,
        });

        const isTrialExpired =
          (user.plan === "trial" && user.days_until_expiration <= -1) ||
          (user.status === "disabled" && user.status_detail === "expired");

        this.setState({
          userType: user.type,
          isTrialExpired: isTrialExpired,
        });

        if (
          window.qb_requestedURL === "/manteinance" ||
          window.qb_requestedURL === "/login" ||
          window.qb_requestedURL === "/signup" ||
          window.qb_requestedURL.match(/\/users\/\S+\/reset_password/) ||
          window.qb_requestedURL.match(/\/sso\//)
        ) {
          let routeToShow = "/";
          if (user.type === "Postmaster") {
            routeToShow = `/domain/${user.domain_code}/email_accounts`;
          } else if (user.type === "EmailAccount") {
            routeToShow = `/home`;
          } else if (user.type === "TeamMember" && !user.permissions.includes("see_domains")) {
            routeToShow = "/";
          } else {
            routeToShow = "/domains";
          }

          // always go to home when app
          if (IS_APP) routeToShow = "/home";

          history.push(routeToShow);
        }

        this.setState({ verifingSession: false });
      })
      .catch((err) => {
        const response = err.response;

        if (response === undefined) {
          // js code error, do nothing
        } else if (response.status === 401) {
          if (window.qb_requestedURL === "/signup") {
            history.push("/signup");
          } else if (
            window.qb_requestedURL.match(/\/users\/\S+\/reset_password/) ||
            window.qb_requestedURL.match(/\/sso\//)
          ) {
            history.push(window.qb_requestedURL);
          } else {
            history.push("/login");
          }
        }

        this.setState({ verifingSession: false });
      });
  };

  showChangePasswordModal = () => {
    this.setState({ changePwdModalOpened: true });
  };

  closeChangePasswordModal = () => {
    this.setState({ changePwdModalOpened: false });
  };

  showForceOTPModal = () => {
    this.setState({ otpModalOpened: true });
  };

  closeForceOTPModal = () => {
    this.setState({ otpModalOpened: false });
  };

  calcMediaQueries = () => {
    let newViewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    let newViewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    this.viewportHeight = newViewportHeight;
    this.viewportWidth = newViewportWidth;
    this.isPortrait = this.viewportHeight > this.viewportWidth;

    document.documentElement.style.setProperty("--vh", `${this.viewportHeight}px`);

    if (window.matchMedia("(min-width: 1280px)").matches) {
      return {
        isMediaMobile: false,
        isMediaSM: false,
        isMediaMD: false,
        isMediaLG: true,
        showSidebar: true,
        compactSidebar: JSON.parse(window.localStorage.getItem("qb_sidebar_compact_status")),
      };
    } else if (window.matchMedia("(min-width: 1024px)").matches) {
      return {
        isMediaMobile: false,
        isMediaSM: false,
        isMediaMD: true,
        isMediaLG: false,
        showSidebar: true,
        compactSidebar: true,
      };
    } else if (window.matchMedia("(min-width: 768px)").matches) {
      return {
        isMediaMobile: false,
        isMediaSM: true,
        isMediaMD: false,
        isMediaLG: false,
        showSidebar: false,
        compactSidebar: false,
      };
    } else {
      return {
        isMediaMobile: true,
        isMediaSM: false,
        isMediaMD: false,
        isMediaLG: false,
        showSidebar: false,
        compactSidebar: false,
      };
    }
  };

  handleResize = () => {
    this.setState(this.calcMediaQueries());
  };

  setShowSidebar = (value) => {
    this.setState({ showSidebar: value });
  };

  setCompactSidebar = (value) => {
    this.setState({ compactSidebar: value });
  };

  componentDidUpdate(prevProps) {
    const { history } = this.props;

    const hasJustLoggedIn = !prevProps.loggedUser && this.props.loggedUser;

    if (hasJustLoggedIn) {
      const user = this.props.loggedUser;
      const isTrialExpired = user.plan === "trial" && user.days_until_expiration <= -1;

      this.setState({
        userType: user.type,
        isTrialExpired: isTrialExpired,
      });

      sessionStore.setSettings({
        language: user.language,
        timezone: user.timezone,
      });

      const showHomeInstead =
        window.qb_requestedURL === "/manteinance" ||
        window.qb_requestedURL === "/login" ||
        window.qb_requestedURL === "/login/" ||
        window.qb_requestedURL === "/signup" ||
        window.qb_requestedURL.match(/\/sso\//) ||
        window.qb_requestedURL.match(/reset_password/);

      let routeToShow = showHomeInstead ? "/home" : window.qb_requestedURL;

      if (routeToShow === "/home") {
        if (user.type === "Postmaster") {
          routeToShow = `/`;
        } else if (user.type === "EmailAccount") {
          routeToShow = `/home`;
        } else if (user.type === "TeamMember" && !user.permissions.includes("see_domains")) {
          routeToShow = "/";
        } else {
          routeToShow = "/domains";
        }
      }

      // always go to home when app
      if (IS_APP) {
        routeToShow = "/home";
      }

      history.push(routeToShow);

      this.setCustomizationInStore(user);

      if (
        user &&
        (user.type === "EmailAccount" || user.type === "Postmaster") &&
        (user.domain_force_otp || user.force_otp) &&
        !user.otp &&
        !this.state.otpModalOpened
      ) {
        return this.showForceOTPModal();
      }

      if (user && (user.password_expired || user.force_new_password)) {
        this.showChangePasswordModal();
      }

      if (user && !user.declared_type && user.type == "Customer" && user.plan == "trial") {
        this.setState({ declareTypeModalOpened: true });
      }

      if (user && user.type === "Customer") {
        this.initializeTour(user);
      }
    }
  }

  continueAuth = () => {
    this.closeForceOTPModal();

    // check if we need to show also the change pwd modal
    if (this.props.loggedUser && (this.props.loggedUser.password_expired || this.props.loggedUser.force_new_password)) {
      this.showChangePasswordModal();
    }
  };

  setCustomizationInStore = (loggedUser = {}) => {
    let logo = loggedUser.customization_logo || window.localStorage.getItem("qb_customization_custom_url_log");
    let company =
      loggedUser.customization_company || window.localStorage.getItem("qb_customization_custom_url_company");

    sessionStore.applyCustomization(
      {
        logo: logo,
        company: company,
        help_desk_url: loggedUser.customization_help_desk_url,
      },
      true
    );
  };

  updatePasswordForm = (field) => {
    this.setState({
      changePasswordForm: { ...this.state.changePasswordForm, ...field },
    });
  };

  updateExpiredPassword = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ updatingPassword: true });
    const account = this.props.loggedUser;

    const values = _.clone(this.state.changePasswordForm);

    if (values.password === "") delete values.password;
    if (values.password_confirmation === "") {
      delete values.password_confirmation;
    }

    const api = new QboxmailApi({ useCookie: true });
    return api
      .editAccount(account.code, values)
      .then(() => {
        this.setState({ updatingPassword: false, changePwdModalOpened: false });
        alertSuccess(t("alert.accountUpdatedSuccess"));
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          this.setState({
            updatingPassword: false,
            changePasswordFormErrors: errors,
          });
        });
        return false; // Promise.reject(response);
      });
  };

  backToLogin = () => this.logout();

  render() {
    const { loggedUser } = this.props;
    const { isTrialExpired, userType, verifingSession, otpModalOpened, declareTypeModalOpened, withTour, runTour } =
      this.state;

    if (loggedUser && loggedUser.status === "disabled" && loggedUser.status_detail !== "expired") {
      return <DisabledAlert user={loggedUser} logout={this.logout} />;
    }

    const childrenProps = {
      logout: this.logout,
      isMobileDevice: this.state.isMobileDevice,
      isMediaMobile: this.state.isMediaMobile,
      isMediaSM: this.state.isMediaSM,
      isMediaMD: this.state.isMediaMD,
      isMediaLG: this.state.isMediaLG,
      showSidebar: this.state.showSidebar,
      compactSidebar: this.state.compactSidebar,
      setCompactSidebar: this.setCompactSidebar,
      setShowSidebar: this.setShowSidebar,
      loggedUser: loggedUser,
    };

    if (verifingSession) {
      return <div />;
    }

    const canRunTour = Boolean(!this.state.isMediaMobile && !this.state.declareTypeModalOpened && withTour);

    return (
      <>
        <Helmet defer={false}>
          <title>{sessionStore.generatePageTitle()}</title>
        </Helmet>

        {isVianovaHost && (
          <Helmet>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            {/* eslint-disable-next-line react/no-unknown-property */}
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
              href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
              rel="stylesheet"
            />
          </Helmet>
        )}

        <AuthContext.Provider
          value={{
            getLoggedUser: () => this.props.loggedUser,
            isLoggedUserAdmin: () => this.props.loggedUser && this.props.loggedUser.type === "Admin",
          }}
        >
          <MediaQueriesContext.Provider
            value={{
              isMobileDevice: this.state.isMobileDevice,
              isMediaMobile: this.state.isMediaMobile,
              isMediaSM: this.state.isMediaSM,
              isMediaMD: this.state.isMediaMD,
              isMediaLG: this.state.isMediaLG,
            }}
          >
            <TourContext.Provider
              value={{ canRunTour, runTour, setRunTour: (value) => this.setState({ runTour: value }) }}
            >
              <Tour isSidebarOpen={childrenProps.showSidebar} />
              <div className="body">
                <ToastContainer />
                {!userType && <NoLoggedRoutes {...childrenProps} />}
                {userType === "Admin" && <AdminRoutes {...childrenProps} />}
                {userType === "Customer" && !isTrialExpired && <CustomerRoutes {...childrenProps} />}
                {userType === "Customer" && isTrialExpired && <TrialExpiredRoutes {...childrenProps} />}
                {userType === "Postmaster" && <PostmasterRoutes {...childrenProps} />}
                {userType === "EmailAccount" && <EmailRoutes {...childrenProps} />}
                {userType === "TeamMember" && <TmRoutes {...childrenProps} />}
                {userType === "Manager" && <ManagerRoutes {...childrenProps} />}

                <Modal
                  title={t("modal.otp.app.title")}
                  opened={otpModalOpened && loggedUser}
                  closeModal={this.closeForceOTPModal}
                  withForm
                >
                  {loggedUser && (
                    <OTPConfig
                      userEmail={loggedUser.email_address}
                      userCode={loggedUser.code}
                      loggedUserType={loggedUser.type}
                      onCancel={this.backToLogin}
                    />
                  )}
                </Modal>
                {loggedUser && userType === "Customer" && loggedUser.plan === "trial" && (
                  <DeclareTypeModal
                    userCode={loggedUser.code}
                    isOpen={declareTypeModalOpened}
                    handleClose={() => this.setState({ declareTypeModalOpened: false })}
                    onSave={this.refreshSession}
                  />
                )}

                {loggedUser && (
                  <ChangePasswordModal
                    opened={this.state.changePwdModalOpened}
                    handleClose={this.closeChangePasswordModal}
                    handleResetPassword={this.updateExpiredPassword}
                    isFormLoading={this.state.updatingPassword}
                    formData={this.state.changePasswordForm}
                    setFormFieldValue={this.updatePasswordForm}
                    formErrors={this.state.changePasswordFormErrors}
                    passwordExpired={loggedUser.password_expired || loggedUser.force_new_password}
                    confirmSelfPassword
                  />
                )}
              </div>
            </TourContext.Provider>
          </MediaQueriesContext.Provider>
        </AuthContext.Provider>
      </>
    );
  }
}

App.contextType = SwrContext;

App.childContextTypes = {
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserTrial: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isLoggedUserExpired: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
  showSidebar: PropTypes.func,
  compactSidebar: PropTypes.func,
};

const mapStateToProps = (state) => ({
  loggedUser: state.session.user,
  loggedUserType: state.session.user ? state.session.user.type : undefined,
  otpSecret: state.resources.otpSecret,
  otp: state.otp,
});

const mapDispatchToProps = (dispatch) => ({
  verify: () => dispatch(sessionActions.verify()),
  logout: () => dispatch(sessionActions.logout()),
  setSession: (user) => dispatch(sessionActions.setSession(user)),
  resetResourcesStore: () => dispatch(resActions.resetResourcesStore()),
});

export { MediaQueriesContext, AuthContext };
export default connect(mapStateToProps, mapDispatchToProps)(view(App));
